import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function StatisticsWishlist({ header, gameId }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:wishlist", { game_id: gameId }));

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <ExportButton
            size="sm"
            prms={{
                "filter-stats_period": apiData.forms_data.filter.data.stats_period,
                "filter-stats_group": apiData.forms_data.filter.data.stats_group,
            }}
        />
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />

            {Object.keys(apiData.stats_summary || {}).length > 0 && (
                <div className="jumbotron p-3 mt-3 mb-0">
                    <h4>
                        {t("За все время")}: {apiData.stats_summary.total}
                    </h4>
                </div>
            )}

            <NothingFilteredAlert />

            {apiData.object_list?.length > 0 && (
                <Table responsive className="dmg-table mt-2">
                    <thead>
                        <tr>
                            <th>{t("Дата")}</th>
                            <th>{t("Количество")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((obj) => (
                            <tr key={obj.dt}>
                                <td>{obj.dt}</td>
                                <td>{obj.cnt}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </ListingCard>
    );
}
